module.exports = __webpack_public_path__ + "resources/icon-dialog-role-arrow-right.c62644674ab10df3.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/component/lottery-dialog-role/img/icon-dialog-role-arrow-right.png
// module id = 818
// module chunks = 0 1